const hoverImageSections = [...document.querySelectorAll('.js-hoverImageSection')]

if (hoverImageSections.length) {
    hoverImageSections.forEach(hoverImageSection => {
        const hoverImage = hoverImageSection.querySelector('.js-hoverImage')
        const hoverImageItems = [...hoverImageSection.querySelectorAll('.js-hoverImageItem')]

        hoverImageItems.forEach(hoverImageItem => {
            const { image } = hoverImageItem.dataset
            
            hoverImageItem.addEventListener('mouseenter', () => {
                hoverImage.src = image
            })
        })
    })
}